import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DataAnalyticsConfigService } from '../data-analytics-config.service';
import { LdsUserService } from './lds-user.service';
@Injectable({
	providedIn: 'root'
})
export class HttpService {

	constructor(
    private http: HttpClient,
    @Inject(DataAnalyticsConfigService) private config,
    private ldsUser: LdsUserService
  ) { }
	getRequest(url, options?): Observable<any> {
		const clientAuthHttpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `bearer ${this.ldsUser.userDetail.tokens.access_token}`,
      })
    };
		if (!options) {
      options = clientAuthHttpOptions;
		}
		return this.http.get<any>(url, options);
	}

	postRequest(url, body, options?): Observable<any> {
		const clientAuthHttpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `bearer ${this.ldsUser.userDetail.tokens.access_token}`
      })
    };
		if (!options) {
      options = clientAuthHttpOptions;
		}
		return this.http.post<any>(url, body, options);
	}

}
